import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
    useLocation,
} from "react-router-dom";

import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import MomPage from "../pages/MomPage";
import AddMom from "../pages/AddMom";
import EditMom from "../pages/EditMom";

import { useAuthStore } from "../service/authStore";

function AppRoutesWrapper() {
    const location = useLocation();

    const urlToken = new URLSearchParams(location.search).get("token");

    const token = useAuthStore((state) => state.token);
    const setSSOToken = useAuthStore((state) => state.setSSOToken);

    useEffect(() => {
        if (urlToken && !token) {
            setSSOToken(urlToken);
        }
    }, [urlToken, token, setSSOToken]);

    const isLoggedIn = !!token;

    return (
        <Routes>
            {!isLoggedIn ? (
                <Route
                    path="*"
                    element={
                        <div
                            style={{
                                height: "100vh",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <h2>Unauthorized</h2>
                        </div>
                    }
                />
            ) : (
                <>
                    {/* Default → MOM list/detail page */}
                    <Route path="/" element={<Navigate to="/mom" replace />} />

                    <Route path="/mom" element={<MomPage />} />
                    <Route path="/mom/add" element={<AddMom />} />
                    <Route path="/mom/edit/:id" element={<EditMom />} />

                    {/* Invalid URL Redirect */}
                    <Route path="*" element={<Navigate to="/mom" replace />} />
                </>
            )}
        </Routes>
    );
}

export default function AppRoute() {
    return (
        <BrowserRouter>
            <AppRoutesWrapper />
            <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                pauseOnHover
                draggable
                theme="light"
            />
        </BrowserRouter>
    );
}